import { Component, Host, h } from '@stencil/core';
import data from '../../docs/docs.json';
import { endpoints } from '../../../.conf/resources';

export interface Component {
  tag: string;
}

@Component({
  tag: 'app-root',
  styleUrl: 'app-root.default.scss',
  /*   styleUrls: {
    default: 'app-root.default.scss',
    dark: 'app-root.dark.scss',
  }, */
  shadow: true,
})
export class AppRoot {
  private components = data.components;
  private pagesBasePath = endpoints.devPagesPath;

  private mapComponents() {
    return this.components.map((component) => this.renderHtml(component));
  }

  private renderHtml(component: Component) {
    if (
      component.tag !== 'app-root' &&
      component.tag !== 'cms-deployment-overview'
    ) {
      return (
        <li class='nav-list'>
          <a class='nav-link' href={this.htmlPageLink(component)}>
            {component.tag}
          </a>
        </li>
      );
    }
  }

  private htmlPageLink(component: Component) {
    return `${this.pagesBasePath}${component.tag}/index.html`;
  }

  async componentWillLoad() {
    console.log('components', this.components);
  }
  render() {
    return (
      <Host>
        <div class={'nav-container'}>
          <ul class={'nav-wrapper'}>{this.mapComponents()}</ul>
        </div>
      </Host>
    );
  }
}
